import { createContext, useContext } from 'react';
import { IAlert } from 'components/atoms/Alert';

export interface IAlertContext {
  setAlert: (type: string, payload: IAlert, infinityAlert?: boolean) => void;
  clearAlert: (type: string) => void;
  roleAlert: null | IAlert;
  dictionaryAlert: null | IAlert;
  userAlert: null | IAlert;
  legalEntityAlert: null | IAlert;
  legalEntityOrgAlert: null | IAlert;
  legalEntityActivateAlert: null | IAlert;
  legalEntityDeactivationWarningsAlert: null | IAlert;
  samePageAlert: null | IAlert;
  taskAlert: null | IAlert;
  intelligenceReportAlert: null | IAlert;
  modalAlert: null | IAlert;
  documentAlert: null | IAlert;
  apiAlert: null | IAlert;
  nextPageAlert: null | IAlert;
  authAlert: null | IAlert;
  transactionAlert: null | IAlert;
  ancillaryAlert: null | IAlert;
  accessoryAlert: null | IAlert;
  ammunitionAlert: null | IAlert;
  componentAlert: null | IAlert;
  trustedDeviceAlert: null | IAlert;
  firearmAlert: null | IAlert;
  auditLogSamePageAlert: null | IAlert;
  addressDeletionAlert: null | IAlert;
  documentsAlert: null | IAlert;
  attachmentAlert: null | IAlert;
  frtAlert: null | IAlert;
  applicationProcessAlert: null | IAlert;
  printoutErrorLogAlert: null | IAlert;
}

export const AlertContext = createContext<IAlertContext>({} as IAlertContext);

export const useAlert = (): IAlertContext => useContext(AlertContext);
